import React, { useState } from "react";

export default function CustomInput({
   id,
   value,
   error,
   touched,
   maxLengthNumber,
   preventNumbers,
   preventLetters,
   allowNumbersAndPlus,
   onlyNumbers,
   placeholder,
   type,
   maxLengthText,
   onCopy,
   onPaste,
   name,
   preventSpecialCharacters,
   customStyle,
   phone,
   onlyUpperCase,
   setFieldValue,
   isDebounced = true,
}) {
   const validateMaxLength = e => {
      if (maxLengthNumber === undefined) {
         return;
      }
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
      if (e.target.value.length > maxLengthNumber) {
         e.target.value = e.target.value.slice(0, maxLengthNumber);
      }
   };
   const preventNumbersFuction = e => {
      if (preventNumbers === undefined) {
         return;
      }
      if (e.keyCode >= 48 && e.keyCode <= 57) {
         e.preventDefault();
      }
   };
   const preventLettersFunction = e => {
      if (preventLetters === undefined) {
         return;
      }
      if (e.keyCode >= 65 && e.keyCode <= 90) {
         e.preventDefault();
      }
   };
   const onlyNumbersFunction = e => {
      if (onlyNumbers === undefined) return;

      const allowedCharacters = /^[0-9]$/;
      if (!allowedCharacters.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
         e.preventDefault();
      }
   };

   const preventSpecialCharactersFunction = e => {
      if (preventSpecialCharacters === undefined) {
         return;
      }
      const allowedCharacters = /^[A-Za-z0-9-\b]+$/;
      if (!allowedCharacters.test(e.key)) {
         e.preventDefault();
      }
   };

   const onlyUpperCaseFunction = e => {
      if (onlyUpperCase !== undefined) {
         e.target.value = e.target.value.toUpperCase();
      }
   };

   const allowNumbersAndPlusFunction = e => {
      if (allowNumbersAndPlus === undefined) return;

      const allowedCharacters = /^[0-9+]+$/;
      if (!allowedCharacters.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
         e.preventDefault();
      }
   };

   const inputOnChange = e => {
      validateMaxLength(e);
      onlyUpperCaseFunction(e);
      handleDebouncedChange(e);
   };
   const inputOnKeyDown = e => {
      preventNumbersFuction(e);
      preventLettersFunction(e);
      preventSpecialCharactersFunction(e);
      allowNumbersAndPlusFunction(e);
      onlyNumbersFunction(e);
   };

   //DEBOUNCE FUNCTION
   const [debouncedValue, setDebouncedValue] = useState(value);
   const [debounceTimeoutId, setDebounceTimeoutId] = useState(null);

   const handleDebouncedChange = event => {
      const { name, value } = event.target;

      if (!isDebounced) {
         setFieldValue(`${name}`, value);
         return;
      }

      if (debounceTimeoutId) {
         clearTimeout(debounceTimeoutId);
      }

      const timeoutId = setTimeout(() => {
         setFieldValue(`${name}`, value);
      }, 400);

      setDebouncedValue(value);
      setDebounceTimeoutId(timeoutId);
   };

   return (
      <>
         {phone ? (
            <div className="placeholder-phone" data-placeholder="07">
               <input
                  id={id}
                  name={name}
                  type={type}
                  value={isDebounced ? debouncedValue : value}
                  onKeyDown={inputOnKeyDown}
                  onChange={inputOnChange}
                  placeholder={placeholder}
                  maxLength={maxLengthText}
                  className={`${customStyle} ${error && touched ? "error-msg-input" : ""}`}
                  onCopy={onCopy}
                  onPaste={onPaste}
               />
            </div>
         ) : (
            <input
               id={id}
               name={name}
               type={type}
               value={isDebounced ? debouncedValue : value}
               onKeyDown={inputOnKeyDown}
               onChange={inputOnChange}
               placeholder={placeholder}
               maxLength={maxLengthText}
               className={`${customStyle} ${error && touched ? "error-msg-input" : ""}`}
               onCopy={onCopy}
               onPaste={onPaste}
            />
         )}

         {error && touched && <div className="error-msg">{error}</div>}
      </>
   );
}
